export default function Title ({ text }) {
  return (
    <h2 className='text-4xl text-gray-900 font-bold md:mb-2'>
      {text}
    </h2>
  )
}
